import React, { type ReactNode, useCallback } from 'react';

import { Filter } from '@pkg/classes';
import { FilterCollection, type FilterCollectionProps } from '@pkg/components/filters';
import { type Collection } from '@pkg/graphql/codegen/graphql';

import { useNFTsFiltersStore } from '@app/store/zustand';

import { Item, List } from './CollectionList.style.ts';

type CollectionSelect = NonNullable<FilterCollectionProps['onSelect']>;

interface CollectionListProps {
    children: ReactNode;
}

interface CollectionItemProps {
    children: ReactNode;
}

export interface CollectionActionProps {
    collectionData: Collection;
}

export function CollectionList({ children }: CollectionListProps) {
    return <List>{children}</List>;
}

function CollectionItem({ children }: CollectionItemProps) {
    return <Item>{children}</Item>;
}

function CollectionAction({ collectionData }: CollectionActionProps) {
    const { currentFilters, setCurrentFilters } = useNFTsFiltersStore();

    const { id, imageUrl, name, marketData } = collectionData;
    const totalSupply = marketData?.totalSupply ?? undefined;

    const selected = currentFilters.hasSomeValue('collections', id);

    const handleSelect: CollectionSelect = useCallback(
        (selectedId) => {
            const updatedFilters = new Filter(currentFilters);
            updatedFilters.toggle('collections', selectedId);

            setCurrentFilters(updatedFilters);
        },
        [currentFilters, setCurrentFilters],
    );

    return (
        <FilterCollection
            id={id}
            name={name}
            imageUrl={imageUrl}
            totalSupply={totalSupply}
            pressed={selected}
            onSelect={handleSelect}
        />
    );
}

CollectionList.Item = CollectionItem;
CollectionList.Action = CollectionAction;
